import { useNavigate } from 'react-router-dom';
import { patchActivateState } from '../../utils/api-calls/patchActivateState';
import { Chatroom } from '../../models';
import { QuickActions } from './UseOpenQuickActionConfirmModal';
import { removeActivityById } from '../../utils';
import { useTranslation } from 'react-i18next';

type ModalProps = {
  room: Chatroom;
  action: QuickActions;
  toggleModal: (
    display: boolean,
    action?: QuickActions,
    room?: Chatroom
  ) => void;
};

export function QuickActionConfirmModal({
  room,
  action,
  toggleModal,
}: ModalProps) {
  const [t] = useTranslation(['common', 'chatroom']);
  const navigate = useNavigate();
  const onCancelClick = () => {
    toggleModal(false);
  };
  const onConfirmClick = async () => {
    if (action === QuickActions.CLOSE) {
      await patchActivateState(room, false);
    } else if (action === QuickActions.DELETE) {
      await removeActivityById(room.activity.id);
    }

    navigate('/loading', { replace: true });
  };

  return room ? (
    <div className="bg-white flex flex-col p-6 w-full rounded-lg">
      <span className="w-full flex justify-center text-xl font-semibold mb-10">
        {action === QuickActions.DELETE
          ? t('confirm_deleting', '確認刪除「{{chatroom}}」嗎？', {
              ns: 'chatroom',
              chatroom: room.name,
            })
          : t('confirm_closing', '確認關閉「{{chatroom}}」嗎？', {
              ns: 'chatroom',
              chatroom: room.name,
            })}
      </span>
      <div className="flex flex-row gap-4 w-full">
        <button
          className="border border-group-primary rounded text-group-primary text-lg text-center flex-grow py-2"
          onClick={onCancelClick}
        >
          {t('cancel', '取消')}
        </button>
        <button
          className="bg-group-primary rounded text-white text-lg text-center flex-grow py-2"
          onClick={onConfirmClick}
        >
          {t('confirm', '確認')}
        </button>
      </div>
    </div>
  ) : (
    <></>
  );
}
